<template>
  <div class="tongue-diagnosis-page">
    <van-nav-bar
      title="舌诊报告"
      left-arrow
      @click-left="onClickLeft"
      fixed
      placeholder
      safe-area-inset-top
    >
      <template #right>
        <van-icon name="ellipsis" size="20" />
        <van-icon name="circle" size="20" style="margin-left: 10px;" />
      </template>
    </van-nav-bar>

    <div class="content-container" v-if="!isLoading && reportData">
      <!-- 顶部切换 Tab -->
      <van-tabs
        v-model="activeTab"
        class="page-tabs"
        color="transparent"
        title-active-color="#2f3134"
        :line-width="0"
      >
        <van-tab title="诊断结果" name="0">
          <DiagnosisResult :reportData="reportData" />
        </van-tab>
        <van-tab title="体质解析" name="1">
          <ConstitutionAnalysis :reportData="reportData" />
        </van-tab>
        <van-tab title="健康分析" name="2">
          <HealthAnalysis :reportData="reportData" />
        </van-tab>
        <van-tab title="调理建议" name="3">
          <ConditioningSuggestions :reportData="reportData" />
        </van-tab>
      </van-tabs>
    </div>

    <!-- 加载中 -->
    <div class="loading-wrap" v-if="isLoading">
      <van-loading type="spinner" color="#44C2C4" size="24px" />
      <span class="loading-text">正在分析舌诊报告...</span>
    </div>
  </div>
</template>

<script>
import { NavBar, Tab, Tabs, Loading, Icon, Toast } from 'vant';
import { post } from '@/utils/request';
import DiagnosisResult from './components/DiagnosisResult.vue';
import ConstitutionAnalysis from './components/ConstitutionAnalysis.vue';
import HealthAnalysis from './components/HealthAnalysis.vue';
import ConditioningSuggestions from './components/ConditioningSuggestions.vue';

export default {
  name: 'MyAiTongueDiagnosis',
  components: {
    [NavBar.name]: NavBar,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    DiagnosisResult,
    ConstitutionAnalysis,
    HealthAnalysis,
    ConditioningSuggestions
  },
  data() {
    return {
      activeTab: '0', // 默认选中诊断结果
      isLoading: true,
      reportData: null,
    };
  },
  created() {
    // 兼容取 id 或 reportId
    const reportId = this.$route.query.id || this.$route.query.reportId;
    if (reportId) {
      this.fetchReportData(reportId);
    } else {
      // 如果没有传id，为了能预览效果，我们也可以暂时先展示骨架或者提示
      // 这里可以先尝试请求一个测试ID，或者直接提示缺少ID
      this.fetchReportData(''); 
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    fetchReportData(reportId) {
      this.isLoading = true;
      post({
        url: "/healthy/auth/consultation/tongueReport",
        data: { reportId: reportId || '' }, 
      })
        .then((res) => {
          const result = res?.data || res || null;
          // 如果存在真实数据，我们将 data 取出，并在本地附加 reportId 以备后续传参
          this.reportData = result ? { ...result, reportId } : null;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          Toast({ message: "获取舌诊报告失败", position: 'middle' });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.tongue-diagnosis-page {
  background: #44C2C4;
  min-height: 100vh;
 
  ::v-deep .van-nav-bar--fixed {
    z-index: 1001;
  }
}

.content-container {
  padding-top: 44px;
  padding-bottom: 20px;
}

.loading-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 100px;
  
  .loading-text {
    margin-top: 16px;
    font-size: 14px;
    color: #fff;
  }
}

/* 自定义 Vant Tabs 样式 */
::v-deep .page-tabs > .van-tabs__wrap {
  position: fixed;
  top: 46px;
  left: 0;
  right: 0;
  background: #cceef2;
  border-bottom: 1px solid #dff4f6;
  z-index: 1000;
}

::v-deep .page-tabs .van-tabs__nav {
  background: transparent;
}

::v-deep .page-tabs .van-tab {
  flex: 1;
  height: 52px;
  font-size: 15px;
  font-weight: 600;
  color: #3b3d40;
  background: #cceef2;
  transition: background-color 0.2s ease;
}

::v-deep .page-tabs .van-tab + .van-tab {
  box-shadow: inset 1px 0 0 rgba(255, 255, 255, 0.9);
}

::v-deep .page-tabs .van-tab--active {
  font-weight: 700;
  background: #fff;
}

::v-deep .page-tabs .van-tab__text {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 8px;
}

::v-deep .page-tabs .van-tab--active .van-tab__text::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3px;
  border-radius: 999px;
  background: #44C2C4;
}

::v-deep .page-tabs .van-tabs__line { 
  display: none;
}

::v-deep .van-tabs__content {
  background: #44C2C4;
  padding: 16px 12px;
}
</style>
